import { ImportTransferCsvBatchResult } from "@redotech/redo-inventory-common/transfer-csv-upload";
import * as z from "zod";

export const uploadTransfersCsv = {
  name: "uploadTransfersCsv" as const,
  input: z.object({}),
  output: ImportTransferCsvBatchResult,
};
